import { useEffect, useState } from 'react'
import { useAuth } from '../store/useAuth'
import { SITE } from '../lib/brand'
import { trialWording } from '../lib/trial'

/**
 * HOW LONG IS LEFT, AND ONLY WHEN THAT IS KNOWN.
 *
 * A thin strip at the top of the workspace and the editor. Three rules, and
 * every one of them is about not lying to somebody about their own account:
 *
 * NOTHING IS INVENTED. Access starts as 'unknown' while the view is read, and
 * a strip that guesses "7 days left" during that moment tells a paying
 * customer he is on a trial. Unknown renders nothing at all. A trial with no
 * end date on it renders nothing either, because the number is the whole
 * message.
 *
 * PAID SEES NOTHING. Not a quieter version of the same bar; nothing.
 *
 * THE LAST DAY IS COUNTED IN HOURS. "1 day left" on a trial with four hours
 * in it is the difference between a contractor renewing tonight and losing
 * tomorrow morning to a locked account.
 *
 * It re-reads itself every fifteen minutes and whenever the tab comes back,
 * because the interesting case is the app left open overnight.
 *
 * It is deliberately NOT rendered inside an export, a printed document or the
 * expanded customer-facing photo. Those are places a homeowner looks.
 */

export default function TrialNotice() {
  const access = useAuth((s) => s.access)
  const allowed = useAuth((s) => s.allowed)
  const trialEndsAt = useAuth((s) => s.trialEndsAt)

  const refreshAccess = useAuth((s) => s.refreshAccess)
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const tick = () => setNow(Date.now())
    const t = setInterval(tick, 15 * 60 * 1000)
    const back = () => {
      if (document.visibilityState !== 'visible') return
      tick()
      // The account itself may have changed while the tab was in the
      // background: a card went through, a trial lapsed.
      void refreshAccess()
    }
    document.addEventListener('visibilitychange', back)
    return () => {
      clearInterval(t)
      document.removeEventListener('visibilitychange', back)
    }
  }, [refreshAccess])

  const said = trialWording(access, trialEndsAt, now, allowed)

  if (!said) return null

  return (
    <div className="ws-trial" role="status">
      <b>{said.text}</b>
      <a href={`${SITE}/#pricing`}>{said.cta} &#8599;</a>
    </div>
  )
}
